import { MoreIcon } from '@persona-id/design-tokens/icons';
import { FC } from 'react';
import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import FeatureFlagged from 'dashboard/components/FeatureFlagged';
import NavBack from 'dashboard/components/NavBack';
import { HeaderContainer } from 'dashboard/layouts/ShowViewLayoutV2';
import Button from 'design-system/components/Button';
import DropdownMenu from 'design-system/components/DropdownMenu';
import { HStack } from 'design-system/components/Stack';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

interface ReportTemplateHeaderProps {
  saveDisabled: boolean;
  reportTemplateVersionId: string;
}

const ReportTemplateHeader: FC<ReportTemplateHeaderProps> = ({
  reportTemplateVersionId,
  saveDisabled,
}) => {
  return (
    <HeaderContainer>
      <Header>
        <NavBack to='/dashboard/report-templates'>All report templates</NavBack>
        <HStack>
          <Button type='submit' disabled={saveDisabled} width='auto'>
            Save report template
          </Button>
          <FeatureFlagged featureFlag='global:enable-platform-connection-dashboard'>
            <DropdownMenu
              trigger={
                <Button aria-label='More actions' type='button' variant='inverse' width='icon'>
                  <MoreIcon />
                </Button>
              }
            >
              <DropdownMenu.Item
                as={Link}
                to={`/dashboard/platform-connections/${reportTemplateVersionId}`}
              >
                Connections
              </DropdownMenu.Item>
            </DropdownMenu>
          </FeatureFlagged>
        </HStack>
      </Header>
    </HeaderContainer>
  );
};

export default ReportTemplateHeader;
